import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h1", null, _toDisplayString(_ctx.title === '对方正在输入' ? _ctx.$t('TUIChat.对方正在输入') : _ctx.title), 1))
}